import React, { useEffect, useState } from "react";
import './aboutUs.css';
import './aboutUs.scss';
import right_section from '../../assets/left-about-us-section.jpg';
import left_section from '../../assets/right-about-us-section.png';
import world from '../../assets/world.png';
import travel from '../../assets/travel (1).png';
import backpack from '../../assets/backpack.png';
import badge from '../../assets/badge.png';
import about_us from '../../assets/aboutus.png';
import let_s from '../../assets/let.png';
import girl from '../../assets/girl.png'

const AboutUs = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  // دالة لحساب نهاية الشهر الحالي
  const getMonthlyDeadline = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    // أول يوم من الشهر القادم
    const nextMonth = new Date(year, month + 1, 1, 0, 0, 0);
    return nextMonth.getTime();
  };
  useEffect(() => {
 const updateCountdown = () => {
      const now = new Date().getTime();
      const deadline = getMonthlyDeadline();
      let distance = deadline - now;

      // لو الوقت عدى، نبدأ العد من جديد للشهر القادم
      if (distance < 0) {
        distance = getMonthlyDeadline() - new Date().getTime();
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      });
    };

    const timer = setInterval(updateCountdown, 1000);
    updateCountdown();
    

    return () => clearInterval(timer); // cleanup
  }, []);

  return (
    <section className="AboutUsContent">
      {/* أول صورة فوق */}
   
      
      {/* سيكشن 1: شمال كلام - يمين صورة */}
      <div className="about-section">
        <div className="about-text">
          <span>About Us – Over Egypt Tours</span>
          <h1>
            We Believe That Travel is More than Just Visiting New Places Experience         
        </h1>
        <p>
            Welcome to Over Egypt Tours, your trusted guide to exploring Egypt. We are a leading travel company that offers unforgettable experiences. Our tours showcase Egypt’s rich history, culture, and beautiful landscapes. We provide personalized guided tours to famous landmarks and unique cultural adventures.
        </p>
        <br />
        <p>At Over Egypt Tours, our mission is to create meaningful journeys that connect you with the heart of Egypt. We focus on high-quality service and memorable experiences. Our vision is to be the top provider of Egypt tours, offering well-crafted itineraries that reveal hidden gems.
        </p>
        <br />
        <p>We believe in building strong connections between our guests and the places they visit. With a passion for travel and respect for Egypt’s heritage, we ensure your trip is more than just a vacation—it’s a memory for life.
        </p>
        <br />
        <p>
            Let us guide you through Egypt for an experience like no other.
        </p>
        </div>
        <div className="about-image">
          <img src={left_section} alt="Our Story" />
        </div>
      </div>
   <div className="twoImages">
        <div className="about-header-image-1">
          <img src={about_us} alt="About Us" />
          <span className="subscribe-circle"></span>
          <img className="girl_image" src={girl} alt="" />
          <img className="let_s_image" src={let_s} alt="" />
        </div>

        <div className="about-header-image-2">
          <img src={about_us} alt="About Us" />
          <div className="subscribe-square">
            <div className="sec-title text-center">
              <div className="section-title text-center">
                <span className="section-title-span">What We’re Offering</span>
                <h2>Get 30% Discount Every Tour</h2>
              </div>
            </div>

            {/* 🟠 العد التنازلي */}
            <div className="time-wepper">
              <div className="time-wepper__item text-center">
                <h4>{timeLeft.days}</h4>
                <span className="time-wepper__item__text">days</span>
              </div>
              <div className="time-wepper__item text-center">
                <h4>{timeLeft.hours}</h4>
                <span className="time-wepper__item__text">hrs</span>
              </div>
              <div className="time-wepper__item text-center">
                <h4>{timeLeft.minutes}</h4>
                <span className="time-wepper__item__text">mins</span>
              </div>
              <div className="time-wepper__item text-center">
                <h4>{timeLeft.seconds}</h4>
                <span className="time-wepper__item__text">secs</span>
              </div>
            </div>

            <div className="tailor-made d-grid">
              <a href="#" className="theme-btn btn-style-three">
                Start Booking
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* سيكشن 2: يمين كلام - شمال صورة */}
      <div className="about-section-2 reverse">
         <div className="about-text-2">
          <span>Why Choose Us</span>
          <div className="feature">
  <div className="icon-wrapper">
    <img src={world} alt="icon" />
  </div>
  <div className="contentt">
    <h3>Expertly Experiences</h3>
    <p>We specialize in journeys that blend comfort culture</p>
  </div>
</div>
<div className="feature">
  <div className="icon-wrapper">
    <img src={travel} alt="icon" />
  </div>
  <div className="contentt">
    <h3>Seamless Travel Plan</h3>
    <p>We make the entire process smooth and stress-free</p>
  </div>
</div>
<div className="feature">
  <div className="icon-wrapper">
    <img src={backpack} alt="icon" />
  </div>
  <div className="contentt">
    <h3>All-Inclusive Packages</h3>
    <p>From flights accommodation sightseeing and activities</p>
  </div>
</div>
<div className="feature">
  <div className="icon-wrapper">
    <img src={badge} alt="icon" />
  </div>
  <div className="contentt">
    <h3>Passionate Quality Travel</h3>
    <p>We are genuinely dedicated turning dream vacation</p>
  </div>
</div>
        </div>
        <div className="about-image-small">
          <img src={right_section} alt="Our Mission" />
        </div>
       
      </div>
       <div className="tailor-made d-flex justify-content-center mt-3">
              <a href="/about-us" className="theme-btn btn-style-three">
                See More
              </a>
            </div>
    </section>
  );
};

export default AboutUs;
